/* NightDrip motion: slow reveal on scroll. Content stays visible if this script never runs. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var els = Array.prototype.slice.call(document.querySelectorAll('[data-reveal]'));
  if (!els.length) return;
  document.documentElement.classList.add('js-motion');
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
  els.forEach(function (el) { io.observe(el); });
  /* Theme editor: show everything immediately */
  if (window.Shopify && window.Shopify.designMode) els.forEach(function (el) { el.classList.add('is-in'); });
})();
